export default __webpack_public_path__ + "static/media/repair-2.94272b26.jpg";